<div class="ds-grid ds-grid--2">
	<!-- Username Validation -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Username Validation</h3>
			<p class="ds-example__header-subtitle">3-20 chars, no spaces, starts with letter</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-input
				#usernameInput
				[label]="'Username'"
				[placeholder]="'Enter username'"
				[fullWidth]="true"
				[validationRules]="formFields.username?.validationRules"
				(valueChange)="onValueChange('username', $event)"
				(validationChange)="onValidationChange('username', $event)">
			</eif-custom-input>
			<eif-custom-button
				[text]="'Validate'"
				[type]="'button'"
				[size]="'small'"
				[preIcon]="'fa-solid fa-check'"
				(action)="usernameInput.validate()">
			</eif-custom-button>
		</div>
		<div class="ds-example__footer">
			<div class="ds-value">
				<div class="ds-value__label">Value:</div>
				<div class="ds-value__content">{{ formFields.username?.value || 'No value' }}</div>
			</div>
			<div class="ds-value ds-mt-1">
				<div class="ds-value__label">Valid:</div>
				<div class="ds-value__content">{{ formFields.username?.valid ? 'Yes' : 'No' }}</div>
			</div>
		</div>
	</div>

	<!-- Email Validation -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Business Email Validation</h3>
			<p class="ds-example__header-subtitle">No personal domains allowed</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-input
				#emailInput
				[label]="'Business Email'"
				[placeholder]="'email@company.com'"
				[fullWidth]="true"
				[validationRules]="formFields.email?.validationRules"
				(valueChange)="onValueChange('email', $event)"
				(validationChange)="onValidationChange('email', $event)">
			</eif-custom-input>
			<eif-custom-button
				[text]="'Validate'"
				[type]="'button'"
				[size]="'small'"
				[preIcon]="'fa-solid fa-check'"
				(action)="emailInput.validate()">
			</eif-custom-button>
		</div>
		<div class="ds-example__footer">
			<div class="ds-value">
				<div class="ds-value__label">Value:</div>
				<div class="ds-value__content">{{ formFields.email?.value || 'No value' }}</div>
			</div>
			<div class="ds-value ds-mt-1">
				<div class="ds-value__label">Valid:</div>
				<div class="ds-value__content">{{ formFields.email?.valid ? 'Yes' : 'No' }}</div>
			</div>
		</div>
	</div>

	<!-- Password Validation -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Complex Password</h3>
			<p class="ds-example__header-subtitle">8+ chars, digit, upper, lower, special</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-input
				#passwordInput
				[label]="'Password'"
				[placeholder]="'Enter password'"
				[type]="'password'"
				[fullWidth]="true"
				[validationRules]="formFields.password?.validationRules"
				(valueChange)="onValueChange('password', $event)"
				(validationChange)="onValidationChange('password', $event)">
			</eif-custom-input>
			<eif-custom-button
				[text]="'Validate'"
				[type]="'button'"
				[size]="'small'"
				[preIcon]="'fa-solid fa-check'"
				(action)="passwordInput.validate()">
			</eif-custom-button>
		</div>
		<div class="ds-example__footer">
			<div class="ds-value">
				<div class="ds-value__label">Value:</div>
				<div class="ds-value__content">{{ formFields.password?.value ? '••••••••' : 'No value' }}</div>
			</div>
			<div class="ds-value ds-mt-1">
				<div class="ds-value__label">Valid:</div>
				<div class="ds-value__content">{{ formFields.password?.valid ? 'Yes' : 'No' }}</div>
			</div>
		</div>
	</div>

	<!-- Phone Validation -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Phone Number</h3>
			<p class="ds-example__header-subtitle">10-digit with valid area code</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-input
				#phoneInput
				[label]="'Phone Number'"
				[placeholder]="'5551234567'"
				[fullWidth]="true"
				[validationRules]="formFields.phone?.validationRules"
				(valueChange)="onValueChange('phone', $event)"
				(validationChange)="onValidationChange('phone', $event)">
			</eif-custom-input>
			<eif-custom-button
				[text]="'Validate'"
				[type]="'button'"
				[size]="'small'"
				[preIcon]="'fa-solid fa-check'"
				(action)="phoneInput.validate()">
			</eif-custom-button>
		</div>
		<div class="ds-example__footer">
			<div class="ds-value">
				<div class="ds-value__label">Value:</div>
				<div class="ds-value__content">{{ formFields.phone?.value || 'No value' }}</div>
			</div>
			<div class="ds-value ds-mt-1">
				<div class="ds-value__label">Valid:</div>
				<div class="ds-value__content">{{ formFields.phone?.valid ? 'Yes' : 'No' }}</div>
			</div>
		</div>
	</div>

	<!-- Credit Card Validation -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Credit Card</h3>
			<p class="ds-example__header-subtitle">13-19 digits with Luhn check</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-input
				#creditCardInput
				[label]="'Credit Card Number'"
				[placeholder]="'Enter card number'"
				[fullWidth]="true"
				[validationRules]="formFields.creditCard?.validationRules"
				(valueChange)="onValueChange('creditCard', $event)"
				(validationChange)="onValidationChange('creditCard', $event)">
			</eif-custom-input>
			<eif-custom-button
				[text]="'Validate'"
				[type]="'button'"
				[size]="'small'"
				[preIcon]="'fa-solid fa-check'"
				(action)="creditCardInput.validate()">
			</eif-custom-button>
		</div>
		<div class="ds-example__footer">
			<div class="ds-value">
				<div class="ds-value__label">Value:</div>
				<div class="ds-value__content">{{ formFields.creditCard?.value ? '••••••••••••' : 'No value' }}</div>
			</div>
			<div class="ds-value ds-mt-1">
				<div class="ds-value__label">Valid:</div>
				<div class="ds-value__content">{{ formFields.creditCard?.valid ? 'Yes' : 'No' }}</div>
			</div>
		</div>
	</div>

	<!-- ZIP Code Validation -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">ZIP Code</h3>
			<p class="ds-example__header-subtitle">5-digit US ZIP code</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-input
				#zipCodeInput
				[label]="'ZIP Code'"
				[placeholder]="'12345'"
				[fullWidth]="true"
				[validationRules]="formFields.zipCode?.validationRules"
				(valueChange)="onValueChange('zipCode', $event)"
				(validationChange)="onValidationChange('zipCode', $event)">
			</eif-custom-input>
			<eif-custom-button
				[text]="'Validate'"
				[type]="'button'"
				[size]="'small'"
				[preIcon]="'fa-solid fa-check'"
				(action)="zipCodeInput.validate()">
			</eif-custom-button>
		</div>
		<div class="ds-example__footer">
			<div class="ds-value">
				<div class="ds-value__label">Value:</div>
				<div class="ds-value__content">{{ formFields.zipCode?.value || 'No value' }}</div>
			</div>
			<div class="ds-value ds-mt-1">
				<div class="ds-value__label">Valid:</div>
				<div class="ds-value__content">{{ formFields.zipCode?.valid ? 'Yes' : 'No' }}</div>
			</div>
		</div>
	</div>
</div>
